import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ReactionLaughingColorIcon = (props: IconProps) => (
  <Icon width="17px" height="16px" viewBox="0 0 17 16" {...props}>
    <circle cx="8.208" cy="8" r="8" fill="#FA3" />
    <path
      fill="#323232"
      d="M8.224 14c2.529 0 4.659-1.675 5.29-3.92.134-.47-.265-.906-.731-.906H3.632c-.466 0-.865.436-.732.905.632 2.246 2.762 3.922 5.324 3.922ZM4.131 3.377c-.266-.134-.566.067-.566.369 0 .067 0 .168.067.235L4.83 5.42 3.632 6.896c-.067.067-.067.168-.067.235 0 .302.3.503.566.369L7.126 5.89a.51.51 0 0 0 0-.905L4.13 3.376Zm8.752.369a.419.419 0 0 0-.6-.369L9.29 4.985a.51.51 0 0 0 0 .905l2.995 1.609a.419.419 0 0 0 .598-.369.364.364 0 0 0-.1-.235l-1.197-1.474 1.198-1.441a.364.364 0 0 0 .1-.235Z"
    />
  </Icon>
);

export default memo(ReactionLaughingColorIcon);
